import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Case } from '../../../domain/case';
import { V3Participant } from '../../../domain/v3Participant';
import { V3Case } from '../../../domain/v3Case';
import { Notification } from '../../../domain/notification';
import { AccountReport } from '../../../domain/accountReport';
import { AccountingPeriod } from '../../../domain/accountingPeriod';
import { CheckinRequest } from '../../../domain/checkinRequest';
import { EmailRequest } from '../../../domain/emailRequest';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  baseUrl: string;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  //TODO
  getUserCases(): Observable<Case[]> {
    return this.http.get<Case[]>(this.baseUrl + 'api/Case/Cases');
  }

  //get case by case number
  getCases(caseNumber): Observable<V3Case> {
    return this.http.get<V3Case>(this.baseUrl + 'api/Case/Find/' + caseNumber);
  }

  getCaseParticipants(caseNumber): Observable<V3Participant[]> {
    return this.http.get<V3Participant[]>(this.baseUrl + 'api/Case/Participants/' + caseNumber);
  }

  registerCase(caseNumber, personId, conservatorName, dob): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'api/Case/Register/', {
      "caseNumber": caseNumber, "personId": personId, "conservatorName": conservatorName, "conservateeDob": dob
    });
  }

  getNotifications(): Observable<Notification[]> {
    return this.http.get<Notification[]>(this.baseUrl + 'api/notification/notifications');
  }

  getAccountReports(searchKey: string): Observable<AccountReport[]> {
    return this.http.get<AccountReport[]>(this.baseUrl + 'api/dashboardreport/reports/' + searchKey);
  }

  getAccountingPeriods(accountingId: number): Observable<AccountingPeriod[]> {
    return this.http.get<AccountingPeriod[]>(this.baseUrl + 'api/accounting/periods/' + accountingId);
  }

  getReportLink(accountingId: number): any {
    return this.http.get<AccountingPeriod[]>(this.baseUrl + 'api/accounting/ReportDocument/' + accountingId);
  }

  checkOut(accountingId: number): any {
    return this.http.post<any>(this.baseUrl + 'api/accounting/checkout/' + accountingId, null);
  }

  getUpdatedData(accountingId: number): any {
    return this.http.post<any>(this.baseUrl + 'api/case/getUpdatedData/' + accountingId, null);
  }
  
  askForCheckin(accountingId: number): any {
    return this.http.post<any>(this.baseUrl + 'api/accounting/askForCheckin/' + accountingId, null);
  }

  sendCheckinResponse(req: CheckinRequest): any {
    return this.http.post<any>(this.baseUrl + 'api/accounting/CheckinResponse/', req);
  }

  checkIn(): any {
    return this.http.post<any>(this.baseUrl + 'api/accounting/checkIn/', null);
  }

  getDocument(path: string): any {
    return this.http.post<AccountingPeriod[]>(this.baseUrl + 'api/document/blob/', { path });
  }

  getHelpContents(): any {
    return this.http.get<any[]>('./api/helpcontent/GetAllFAQs');
  }

  getTutorials(): any {
    return this.http.get<any[]>('./api/dashboardcontent/GetAllTutorials');
  }

  getDashboardLinks(): any {
    return this.http.get<any[]>('./api/dashboardcontent/GetAllDashboardLinks');
  }

  sendEmail(req: EmailRequest): any {
    var result = this.http.post<any>(this.baseUrl + 'api/Communicator/SendEmail', req);    
    return result;
  }
}
